module.exports = __webpack_public_path__ + "static/media/progman_22.3ba20826.ico";